import { render } from "./landingPage.vue?vue&type=template&id=30d45568&scoped=true"
import script from "./landingPage.vue?vue&type=script&lang=js"
export * from "./landingPage.vue?vue&type=script&lang=js"

import "./landingPage.vue?vue&type=style&index=0&id=30d45568&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d45568"]])

export default __exports__